import React, { memo, useCallback, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { Button, Col, Form, Input, Row, Space, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import { CONTRACT_ACTION } from '@/constants/contract';
import { hideModal } from '@/store/actions/modalsActions';
import Modal from '@/views/modals/Modal';
import statusType from '@/store/constants/statusType';

import { MODALS } from '..';

import classes from './ConfirmContractTerminate.module.scss';

const { Title, Text } = Typography;

const ConfirmContractTerminate = props => {
  const { onOk } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [comment, setComment] = useState();

  const status = useSelector(state => state.contract?.[CONTRACT_ACTION.TERMINATE_CONTRACT]?.status);

  const handleChangeComment = useCallback(event => {
    const { value } = event.target;
    setComment(value);
  }, []);

  const handleClickNo = useCallback(() => {
    dispatch(hideModal(MODALS.ConfirmContractTerminate));
  }, [dispatch]);

  const handleClickYes = useCallback(() => {
    if (onOk) {
      onOk(comment);
    }
  }, [onOk, comment]);

  return (
    <Modal name={MODALS.ConfirmContractTerminate} width={468}>
      <Row gutter={[0, 22]}>
        <Col span={24}>
          <Title level={4}>{t('modal.confirm-contract-terminate.title')}</Title>
          <Text className={classes.description}>{t('modal.confirm-contract-terminate.description')}</Text>
        </Col>
        <Col span={24}>
          <Form layout="vertical">
            <Form.Item label={t('modal.confirm-contract-terminate.reason')}>
              <Input.TextArea placeholder={t('placeholder.comment')} onChange={handleChangeComment} />
            </Form.Item>
          </Form>
        </Col>
        <Col span={24}>
          <Row justify="end">
            <Space>
              <Button shape="round" onClick={handleClickNo}>
                {t('modal.confirm-contract-terminate.button.no')}
              </Button>
              <Button type="primary" shape="round" loading={status === statusType.LOADING} onClick={handleClickYes}>
                {t('modal.confirm-contract-terminate.button.yes')}
              </Button>
            </Space>
          </Row>
        </Col>
      </Row>
    </Modal>
  );
};

export default memo(ConfirmContractTerminate);
